/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Progress_LabelInputs */

const en_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload progress`)
};

const fr_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression du téléversement`)
};

const de_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload-Fortschritt`)
};

const it_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento in corso`)
};

const ru_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ход загрузки`)
};

const es_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de subida`)
};

const zh_cn2_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传进度`)
};

const ja_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードの進行状況`)
};

const hi_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपलोड प्रगति`)
};

const pt_pt2_upload_progress_label = /** @type {(inputs: Upload_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso do carregamento`)
};

/**
* | output |
* | --- |
* | "Upload progress" |
*
* @param {Upload_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upload_progress_label = /** @type {((inputs?: Upload_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_upload_progress_label(inputs)
	if (locale === "de") return de_upload_progress_label(inputs)
	if (locale === "it") return it_upload_progress_label(inputs)
	if (locale === "ru") return ru_upload_progress_label(inputs)
	if (locale === "es") return es_upload_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_upload_progress_label(inputs)
	if (locale === "ja") return ja_upload_progress_label(inputs)
	if (locale === "hi") return hi_upload_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_upload_progress_label(inputs)
	return en_upload_progress_label(inputs)
});